import React from "react";
import { Link } from "react-router-dom";

// Cyberpunk FFA monogram in black & gold
export default function Logo({ size = "md", showText = true }) {
  const dims = size === "lg" ? 44 : size === "sm" ? 28 : 36;
  return (
    <Link to="/" className="flex items-center gap-3 group" aria-label="Fidelity Federal Associates home">
      <div className="relative" style={{ width: dims, height: dims }}>
        <svg viewBox="0 0 48 48" width={dims} height={dims} className="transition-transform duration-500 group-hover:rotate-[2deg]">
          <defs>
            <linearGradient id="ffaGold" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#f4e2a8" />
              <stop offset="50%" stopColor="#c8a951" />
              <stop offset="100%" stopColor="#9c7b2e" />
            </linearGradient>
          </defs>
          {/* angular cyberpunk frame */}
          <path
            d="M4 4 H44 V32 L32 44 H4 Z"
            fill="#0c0c0e"
            stroke="url(#ffaGold)"
            strokeWidth="1.5"
          />
          <path d="M4 4 H16 L13 8 H8 V13 L4 16 Z" fill="url(#ffaGold)" opacity="0.85" />
          <text
            x="24"
            y="30"
            textAnchor="middle"
            fontFamily="'Space Grotesk', sans-serif"
            fontSize="15"
            fontWeight="700"
            letterSpacing="-0.5"
            fill="url(#ffaGold)"
          >
            FFA
          </text>
        </svg>
      </div>
      {showText && (
        <div className="leading-none">
          <span className="font-display text-[15px] font-semibold tracking-tight text-stone-50 block">
            Fidelity Federal
          </span>
          <span className="font-mono-l text-[10px] tracking-[0.25em] uppercase text-stone-400">
            Associates LLC
          </span>
        </div>
      )}
    </Link>
  );
}
